import React from "react";
import QuillEditor from "../../react-quill-editor/quillEditor/quillEditor";
export interface Props {title : string, name : string, value : string, setData : Function}
export const ContentsEditorBox:React.FC<Props> = ({title, name, value, setData}) => {
    const handleChange = (e:any) => {
        setData((prev:any)=>({...prev, [name] : e}))
    }
    return(
        <>
        <tr className="lang_separation active">
            <th>본문(국문)</th>
            <td>
                <QuillEditor value={value} onChange={handleChange}/>
            </td>
        </tr>
        </>
    )
}